export class FechaUtils {
  static getPrimerDiaMes() {
    return new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  }

  static getMesAntes() {
    return new Date(new Date().getFullYear(), new Date().getMonth() - 1, new Date().getDate());
  }

  static getSeisMesesAntes() {
    return new Date(new Date().getFullYear(), new Date().getMonth() - 6, new Date().getDate());
  }

  static getAnioAntes() {
    return new Date(new Date().getFullYear() - 1, new Date().getMonth(), new Date().getDate());
  }

  static getFechaFin(fecha) {
    const fechaTemp = new Date(fecha);

    const resultado = new Date(fechaTemp.setHours(23, 59, 59));

    return resultado;
  }

  static getFechaInicio(fecha) {
    const fechaTemp = new Date(fecha);

    const resultado = new Date(fechaTemp.setHours(0, 0, 0));

    return resultado;
  }

  static getHoyInicio() {
    return this.getFechaInicio(new Date());
  }

  static getHoyFin() {
    return this.getFechaFin(new Date());
  }
}
